import { Component } from '@angular/core';
import { ModalService } from '../../../../../../../coverpath-common/angular/services/modal/modal.service';
import { AccountCenterService } from '../../../../../../../coverpath-common/angular/services/account-center/account-center.service';
import { AmorphicService } from '../../../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { Controller } from '../../../../../../../coverpath-client/public/js/Controller';

@Component({
  selector: 'policy-docs-split',
  moduleId: module.id,
  templateUrl: './policy-docs-split.component.html',
})
export class PolicyDocsComponentSplit {
  controller: Controller;
  termLink: string;
  wholeLink: string;

  constructor(
    private amorphicService: AmorphicService,
    private modalService: ModalService,
    private accountCenterService: AccountCenterService
  ) {
    this.controller = this.amorphicService.controller as Controller;
    this.wholeLink = this.controller.accountCenterController.getViewPolicyAdminDocsURL('primary');
    this.termLink = this.controller.accountCenterController.getViewPolicyAdminDocsURL('secondary');
  }

  ngOnInit(): void {}

  exit() {
    this.modalService.deactivate();
  }
}
